import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import { createBrowserHistory } from "history";
import 'react-toastify/dist/ReactToastify.min.css';
import 'mobx-react-lite/batchingForReactDom'
import 'react-datepicker/dist/react-datepicker.min.css'

// const baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
const rootElement = document.getElementById('root');

export const history = createBrowserHistory();

ReactDOM.render(
  <Router history={history}>
    <App />
  </Router>,
  rootElement);

//registerServiceWorker();

